import { render } from "./report-add.vue?vue&type=template&id=9aa098ea&scoped=true&ts=true"
import script from "./report-add.vue?vue&type=script&lang=ts"
export * from "./report-add.vue?vue&type=script&lang=ts"

import "./report-add.vue?vue&type=style&index=0&id=9aa098ea&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa098ea"]])

export default __exports__